module.exports = __webpack_public_path__ + "img/lange_crub_4.9ee534d5.jpg";